import React, {useEffect} from "react";
import RIcon from "../../assets/DashBoard/r-icon.svg";
import HIcon from "../../assets/DashBoard/h-icon.svg";
import JIcon from "../../assets/DashBoard/j-icon.svg";
import IIcon from "../../assets/DashBoard/i-icon.svg";
import { Dashboard_PortfolioScheme } from "./schema/Dashboard_PortfolioSchema";
import DashBoardFooter from "../../assets/DashBoard/dashboard-footer.svg";
import DashboardRecentActivity from "./DashboardRecentActivity";
import crossImg from "../../assets/DashBoard/dashboardcross.svg";
import newCreateDemat from "../../assets/DashBoard/newCreateDemat.png"

import {toIndianCurrencywithoutSymbol} from "../../helperFunctions/helperFunctions"
import { Link } from "react-router-dom";

const DashboardPortfolio = ({
  response
}) => {
  // console.log(response)

  // let json = [
  //   {Unit_Code: "SOE  ",
  //   Unit_Name: "JTEKT INDIA LIMITED",
  //   current_value: 0,
  //   dividends_recd: 50,
  //   holding: 0
  // },
  //   {
  //     Unit_Code: "WPL  ",
  //     Unit_Name: "WIPRO LIMITED",
  //     current_value: 6052,
  //     dividends_recd: 0,
  //     holding: 10,
  //   }
  // ]
  // console.log(json);
  // response = json
  const portFolioDetails = response.filter(item => item.holding != 0);
 
  //removing quality 0 here
  // portFolioDetails  = portFolioDetails.filter(item => item.portFolioDetails != 0);

 

  return (
    <div>
      <div className="hide-md">
        <div className="row">
          <div className="col-md-8">
            <div className="LogoText">
              <span className="WelcomeTxt">Welcome</span>
              <span className="IpoTxt">
                Get all the latest news on recent & upcoming IPOs
              </span>
              <img src={DashBoardFooter} className="w-100" />
            </div>

            <div className="showMobile">
              <div className="addBackImg">
                <h4 className="coloredp">Welcome !</h4>
                <p className="cbla">Get all the latest news on recent & upcoming IPOs</p>
                <img src={crossImg} alt='img' className="imgce" />
              </div>
            </div>

            <h5 className="my-4 aligCinMob">Portfolio</h5>
            <div className="card-sm p-2 p-md-2 hideMobile">
              <div className="row portfolio">
                <div className="tab-content pb-4">
                  
                  {
                      portFolioDetails && portFolioDetails.length >0 &&
                  
                  <div id="equity" className="tab-pane active">
                    {portFolioDetails && portFolioDetails.map((item, index) => {
                      
                      return (
                        
                          <div className="row col-md-12 mx-auto mb-5" key={index}>
                            <h6 className=" my-3 colorcocompnamedash">
                              {/* Reliance */}
                              {item.Unit_Name}
                            </h6>

                            <div className="card p-0">
                              <div className="table-responsive">
                                <table className="table mb-0 dashboardTable">
                                  <thead>
                                    <tr>
                                      <th>Quantity</th>
                                      <th>Current Amount</th>
                                      <th>Dividend Received</th>
                                      {/* <th>Dividend Unpaid</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr key={index}>
                                      <td>{item.holding}</td>
                                      <td>{(item.current_value && item.current_value != null) ?(toIndianCurrencywithoutSymbol(Number(item.current_value))): '0'}</td>
                                      {/* <td>{item.dividends_recd}</td> */}
                                      <td>{(item.dividends_recd && item.dividends_recd != null) ?(toIndianCurrencywithoutSymbol(Number(item.dividends_recd))): '0'}</td>
                                      {/* <td>{item.dividends_recd}</td> */}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        
                      );
                    })}

                    <p className="notInfoportfiliobottom">*The data shown for KFintech Serviced Issues only</p>
                  </div>
                  }
                  <div id="equity" className="tab-pane active">

                  {portFolioDetails.length == 0 &&
                      <div className="norecords">
                      <p>No Records Found</p>
                    </div>
                  }

                    </div>
                </div>
              </div>
            </div>

           
             {
               portFolioDetails && portFolioDetails.length > 0 && 
             
               <div className="showMobile">
            <div className="showMobile">
              {portFolioDetails && portFolioDetails.length > 0 && portFolioDetails.map((item,index) => {
                return (
                  <div className="portFMobile" key={index}>
                    <div className="firstHeadre">
                      <p> {item.Unit_Name}</p>
                    </div>

                    <div className="indetailsmobvaluecoloredPortfolio">
                      <p className="transactinDashLablePort">Quantity</p>
                      <p className="transactinDashValuePort">{item.holding}</p>
                    </div>

                    <div className="indetailsmobvaluecoloredPortfolio">
                      <p className="transactinDashLablePort">Current Amount</p>
                      <p className="transactinDashValuePort">{(item.current_value && item.current_value != null) ?(toIndianCurrencywithoutSymbol(Number(item.current_value))): '0'}
                        </p>
                    </div>

                    <div className="indetailsmobvaluecoloredPortfolio">
                      <p className="transactinDashLablePort">Dividend Received</p>
                      <p className="transactinDashValuePort">{(item.dividends_recd && item.dividends_recd != null) ?(toIndianCurrencywithoutSymbol(Number(item.dividends_recd))): '0'}</p>
                    </div>

                    {/* <div className="indetailsmobvaluecoloredPortfolio">
                      <p className="transactinDashLablePort">Dividend Unpaid</p>
                      <p className="transactinDashValuePort">{item.dividends_recd}</p>
                    </div> */}


                  </div>
                )
              })

              }
            </div>
          <p className="notInfoportfiliobottom">*The data shown for KFintech Serviced Issues only</p>
          </div>
          }

          

            <div className="showMobile">
            {portFolioDetails.length == 0 &&
                      <div className="norecords">
                      <p>No Records Found</p>
                    </div>
                  }
</div>
          </div>

          <div className="col-md-4">
            {/* <DashboardRecentActivity /> */}
            <div className="newDesignTemp">
                <img src={newCreateDemat} alt="tempimg" className="tempImg" />
                  <div className="dematrightAlign">
                    <p className="nameheader">Open Demat Account</p>
                    <p className="descInfo">From a broker of your choice</p>
                    <Link  to={{pathname:"/home/createDemat"}}><button className="clickBtn">Click Here</button></Link>
                  </div>
                  
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPortfolio;